import moment from 'moment';

import { Formats } from './constants';

const normalize = {
  date(value) {
    if (!value) {
      return value;
    }

    if (!moment(value, Formats, true).isValid()) {
      return value;
    }

    return moment(value, Formats, true).format('YYYY-MM-DD');
  },
};

export default normalize;
